module.exports = __webpack_public_path__ + "img/figure.a6dfe613.png";